import React, { useState } from "react";
import "./RedeemLoyaltyCheckbox.scss";

interface RedeemLoyaltyCheckboxProps {
  points: number;
  onChange: (checked: boolean) => void;
}

const RedeemLoyaltyCheckbox: React.FC<RedeemLoyaltyCheckboxProps> = ({ points, onChange }) => {
  const [checked, setChecked] = useState(false);

  const handleChange = () => {
    const newValue = !checked;
    setChecked(newValue);
    onChange(newValue);
  };

  return (
    <label className="redeem-loyalty-checkbox">
      <input type="checkbox" checked={checked} onChange={handleChange} />
      <span className="checkmark"></span>
      Redeem {points} points for this booking
    </label>
  );
};

export default RedeemLoyaltyCheckbox;
